import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../../Accordion/Accordion.js";
import Polischuk from "../../../Data/Protection/advertisementsDataPolischuk.json";
import Levchik from "../../../Data/Protection/advertisementsDataLevchik.json";
import Alhashash from "../../../Data/Protection/advertisementsDataAlhashash.json";
import Uryupina from "../../../Data/Protection/advertisementsDataUryupina.json";
import Stukova from "../../../Data/Protection/advertisementsDataStukova.json";
import Kuklin from "../../../Data/Protection/advertisementsDataKuklin.json";
import Polyakova from "../../../Data/Protection/advertisementsDataPolyakova.json";
import Burkhanova from "../../../Data/Protection/advertisementsDataBurkhanova.json";
import Amozov from "../../../Data/Protection/advertisementsDataAmozov.json";
import Bakurov from "../../../Data/Protection/advertisementsDataBakurov.json";
import Baytyakov from "../../../Data/Protection/advertisementsDataBaytyakov.json";
import Bolotov from "../../../Data/Protection/advertisementsDataBolotov.json";
import Capuler from "../../../Data/Protection/advertisementsDataCapuler.json";
import Gorbunov from "../../../Data/Protection/advertisementsDataGorbunov.json";
import Ibliyaminova from "../../../Data/Protection/advertisementsDataIbliyaminova.json";
import Ignatenko from "../../../Data/Protection/advertisementsDataIgnatenko.json";
import Kashcheeva from "../../../Data/Protection/advertisementsDataKashcheeva.json";
import Kazarin from "../../../Data/Protection/advertisementsDataKazarin.json";
import Kenixfest from "../../../Data/Protection/advertisementsDataKenixfest.json";
import Koryukina from "../../../Data/Protection/advertisementsDataKoryukina.json";
import Kuznechenkova from "../../../Data/Protection/advertisementsDataKuznechenkova.json";
import Kuznetsova from "../../../Data/Protection/advertisementsDataKuznetsova.json";
import Lesnaya from "../../../Data/Protection/advertisementsDataLesnaya.json";
import Letaeva from "../../../Data/Protection/advertisementsDataLetaeva.json";
import Lyakhovetsky from "../../../Data/Protection/advertisementsDataLyakhovetsky.json";
import Novgorodova from "../../../Data/Protection/advertisementsDataNovgorodova.json";
import Pazina from "../../../Data/Protection/advertisementsDataPazina.json";
import Semenov from "../../../Data/Protection/advertisementsDataSemenov.json";
import Shabardina from "../../../Data/Protection/advertisementsDataShabardina.json";
import Sorokina from "../../../Data/Protection/advertisementsDataSorokina.json";
import Tolstaya from "../../../Data/Protection/advertisementsDataTolstaya.json";
import Topychkanova from "../../../Data/Protection/advertisementsDataTopychkanova.json";
import Ufimtseva from "../../../Data/Protection/advertisementsDataUfimtseva.json";
import Volkova from "../../../Data/Protection/advertisementsDataVolkova.json";
import Rustamkhanova from "../../../Data/Protection/advertisementsDataRustamkhanov.json";

export default function Advertisements() {
  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Объявления о защите кандидатских и докторских диссертаций
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 26.12.2025 Рустамханова
          Гульназ Радиковна
        </h3>

        {/* <h3 className="about-nii__title antiCorruption__title">
          Диссертация Рустамхановой Г.Р. снята с рассмотрения по личному
          заявлению соискателя от 24.11.2025 г.
        </h3> */}

        {/* <p>
          26.11.2025 г. в 11:00 состоится заседание Диссертационного совета
          72.1.018.01, посвященное защите диссертации на соискание ученой
          степени кандидата медицинских наук "Совершенствование комплексной
          терапии больных онихомикозом и микозом стоп с учетом показателей
          метаболической активности микрофлоры кишечника" Рустамхановой Гульназ
          Радиковны. <br></br>
          <br></br>Место проведения заседания Диссертационного совета
          72.1.018.01: Государственное бюджетное учреждение Свердловской области
          "Уральский научно-исследовательский институт дерматовенерологии и
          иммунопатологии", г. Екатеринбург, ул. Щербакова, д. 8.
        </p> */}

        <Accordion data={Rustamkhanova} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 11.10.2024 Полищук Антон
          Ильич
        </h3>

        <Accordion data={Polischuk} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 26.08.2024 Левчик Надежда
          Константиновна
        </h3>

        <Accordion data={Levchik} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 27.12.2021 Альхашаш Субхи
          М.С.
        </h3>

        <Accordion data={Alhashash} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 24.12.2021 Урюпина Елена
          Львовна
        </h3>

        <Accordion data={Uryupina} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 24.12.2019 Стукова Евгения
          Игоревна
        </h3>

        <Accordion data={Stukova} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о рассмотрении диссертации от 09.12.2019 Куклин Игорь
          Александрович
        </h3>

        <Accordion data={Kuklin} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 29.12.2016 Полякова
          Наталия Владимировна
        </h3>

        <Accordion data={Polyakova} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.09.2014 Бурханова
          Наира Рифовна
        </h3>

        <Accordion data={Burkhanova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.09.2014 Топычканова
          Елизавета Павловна
        </h3>

        <Accordion data={Topychkanova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.09.2014 Семенова
          Инна Викторовна
        </h3>

        <Accordion data={Semenov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.11.2013 Сорокина
          Ксения Николаевна
        </h3>

        <Accordion data={Sorokina} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.11.2013 Волкова
          Наталья Владимировна
        </h3>

        <Accordion data={Volkova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.11.2013 Толстая
          Анастасия Игоревна
        </h3>

        <Accordion data={Tolstaya} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 26.09.2013 Кузнецова
          Юлия Николаевна
        </h3>

        <Accordion data={Kuznetsova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 23.08.2013 Игнатенко
          Ирины Евгеньевны
        </h3>

        <Accordion data={Ignatenko} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 17.05.2013 Новгородова
          Татьяна Ивановна
        </h3>

        <Accordion data={Novgorodova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 26.11.2012 Ляховецкий
          Богдан Иванович
        </h3>

        <Accordion data={Lyakhovetsky} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 03.10.2012 Байтяков
          Владимир Викторович
        </h3>

        <Accordion data={Baytyakov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.08.2012 Летаева
          Ольга Владимировна
        </h3>

        <Accordion data={Letaeva} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.03.2012 Казарин
          Сергей Владимирович
        </h3>

        <Accordion data={Kazarin} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 24.03.2012 Кащеева Яна
          Викторовна
        </h3>

        <Accordion data={Kashcheeva} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 28.01.2012 Амозов
          Аркадий Михайлович
        </h3>

        <Accordion data={Amozov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 28.01.2012 Бакуров
          Евгений Викторович
        </h3>

        <Accordion data={Bakurov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 14.10.2011 Болотов
          Павел Дмитриевич
        </h3>

        <Accordion data={Bolotov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 28.09.2011 Капулер Ольга
          Марселевна
        </h3>

        <Accordion data={Capuler} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 28.09.2011 Кениксфест
          Юлия Владимировна
        </h3>

        <Accordion data={Kenixfest} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 08.08.2011 Лесная Ирина
          Николаевна
        </h3>

        <Accordion data={Lesnaya} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите докторской диссертации от 05.08.2011 Уфимцева
          Марина Анатольевна
        </h3>

        <Accordion data={Ufimtseva} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 10.04.2011
          Кузнеченкова Татьяна Владимировна
        </h3>

        <Accordion data={Kuznechenkova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 10.04.2011 Иблияминова
          Альфия Аксановна
        </h3>

        <Accordion data={Ibliyaminova} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 10.10.2010 Горбунов
          Андрей Петрович
        </h3>

        <Accordion data={Gorbunov} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 10.10.2010 Корюкина
          Елена Борисовна
        </h3>

        <Accordion data={Koryukina} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 26.11.2010 Пазина
          Марина Владимировна
        </h3>

        <Accordion data={Pazina} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Объявление о защите кандидатской диссертации от 26.11.2010 Шабардина
          Ольга Владимировна
        </h3>

        <Accordion data={Shabardina} />
      </div>
    </section>
  );
}
